import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const RequestsIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <g
      fill="none"
      stroke={color}
      strokeWidth={1.5}
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path
        d="M10.626 15.635H5.465c-2.156 0-3.92-1.568-3.92-3.484V6.12c0-1.916 1.764-3.484 3.92-3.484h5.16c2.156 0 3.92 1.568 3.92 3.484v6.032c0 1.916-1.764 3.484-3.92 3.484zM5.667 7.263l2.696 3.488M16.42 2.192L8.364 10.75M17.123 3.735v-2.2M17.123 1.536h-2.239"
      />
    </g>
  </svg>
);

RequestsIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

RequestsIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(18, 17),
};

export default RequestsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/requests.js